const DISMISS_API_ENDPOINT = '/api/dismiss-content';

export class DismissibleContent extends HTMLElement
{

    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.createPopover();
        this.initEventListeners();
    }

    createPopover()
    {
        const popover = document.createElement('pop-over');
        popover.textContent = 'Click to Dismiss';
        this.appendChild(popover);
    }

    initEventListeners()
    {
        const contentElement = this.querySelector('[data-content_id]');
        if (!contentElement) {
            return;
        }

        const contentId = contentElement.getAttribute('data-content_id');
        if (!contentId) {
            return;
        }

        contentElement.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleDismissedContentClick(contentId, contentElement);
        });
    }

    handleDismissedContentClick(contentId, element)
    {
        
        // add to dismissed list 
        fetch(DISMISS_API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                content_id: contentId
            })
        }).then(response => {
            if (response.ok) {
                // hide the badge
                element.style.display = 'none';
            } else {
                console.error('Failed to disregard the new badge');
            }
        }).catch(error => {
            console.error('Error disregarding the new badge:', error);
        });

    }

}

customElements.define('dismissible-content', DismissibleContent);

